import type { TOC } from '@ember/component/template-only';
// @ts-expect-error: Missing type
import InfiniteScroller from '@zestia/ember-simple-infinite-scroller/components/infinite-scroller';

interface PrismComboSelectInputUnsafeInfiniteScrollContainerSignature {
  Args: {
    isInfiniteScrollEnabled: boolean;
    onLoadMore: () => unknown;
    percent: number;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

/**
 * Container component that either renders with or without the infinite scroll wrapper based
 * on the `isInfiniteScrollEnabled` argument.
 */
const PrismComboSelectInputUnsafeInfiniteScrollContainer = <template>
  {{#if @isInfiniteScrollEnabled}}
    <InfiniteScroller
      @onLoadMore={{@onLoadMore}}
      @percent={{@percent}}
      ...attributes
    >
      {{yield}}
    </InfiniteScroller>
  {{else}}
    {{yield}}
  {{/if}}
</template> satisfies TOC<PrismComboSelectInputUnsafeInfiniteScrollContainerSignature>;

export default PrismComboSelectInputUnsafeInfiniteScrollContainer;
